import React from 'react';

import { Button } from '@mui/material';

import { useEventContext } from '@/components/shared/events/EventContext';

import { InitialScoutCalendarState } from '../../../ScoutCalendar/reducer';

import type { SxProps, Theme } from '@mui/material';

interface CreateEventButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  createMultiple?: boolean;
  className?: string;
  id?: string;
}

const CreateEventButton = ({
  variant = 'contained',
  sx,
  children = 'Create event',
  createMultiple = false,
  className,
  id
}: CreateEventButtonProps) => {
  const { dispatch } = useEventContext();

  const handleCreateEvent = () => {
    dispatch({ type: 'CREATE_MULTIPLE_EVENTS', payload: createMultiple });
    dispatch({
      type: 'SET_CREATE_EVENT_OBJECT',
      payload: {
        ...InitialScoutCalendarState.createEventObject,
        eventDate: new Date(),
        dates: [new Date()],
        step: 1
      }
    });
    dispatch({ type: 'SET_SHOW_CREATE_EVENT_MODAL', payload: true });
    window.history.pushState(null, '', createMultiple ? '?new_multiple' : '?new');
  };

  return (
    <Button className={className} id={id} onClick={handleCreateEvent} sx={sx} variant={variant}>
      {children}
    </Button>
  );
};

export default CreateEventButton;
